import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";
import { ArrowLeft } from "lucide-react";

export default function AcademyArticle() {
  const { slug } = useParams();
  const [art, setArt] = useState(null);
  useEffect(() => {
    api.get(`/academy/${slug}`).then((r) => setArt(r.data)).catch(() => setArt(false));
  }, [slug]);

  return (
    <MarketingLayout>
      <Seo title={art ? art.title : "Academy"} description={art ? art.excerpt : ""} />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <Link to="/academy" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Back to Academy</Link>
        {art === false && <p className="mt-8 text-muted-foreground">Article not found.</p>}
        {art && (
          <article className="mt-6">
            <div className="text-xs font-semibold uppercase tracking-wider text-accent">{art.category}</div>
            <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">{art.title}</h1>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground">{art.body}</p>
          </article>
        )}
      </div>
    </MarketingLayout>
  );
}
